.menuContainer{
  background-color: #fff;
}
.menuList{
  width: 300px;
}
.menuItem{
  position: relative;
}
.menuItemText {
  fontWeight: 500;
}
